module.exports = __webpack_public_path__ + "f4f5ecf113c24c22cdc9c78b305448b9.pdf";